import { getAll, get, getById } from "@/utilities/querySelector";
import { toggleScroll } from "@/utilities/toggleScroll";


const header = getById( 'site-header' );
const mobileMenuToggle = getById( 'mobile-menu-toggle' );
const mobileMenu = getById( 'mobile-menu' );
const sideMenu = getById( 'side-menu' );
const sideMenuOpen = getById( 'side-menu-open' );
const sideMenuClose = getById( 'side-menu-close' );
const splitNav = get( '.split-nav' );

if (mobileMenuToggle) {
    mobileMenuToggle?.addEventListener( 'click', () => {
        toggleMenu( 'mobile' );
    } );
}

if (mobileMenu) {
    getAll( 'a', mobileMenu ).forEach( link => {
        link.addEventListener( 'click', () => {
            closeMenus();
        } );
    } );
}

if (sideMenuOpen) {
    sideMenuOpen?.addEventListener( 'click', () => {

        const header = getById('site-header');
        const headerHeight = header.offsetHeight;
        header.style.setProperty('--header-height', `${headerHeight}px`);

        toggleMenu( 'side' );

        document.addEventListener('click', (event) => {
            if (header?.getAttribute('data-menu-active') === 'side' && !sideMenu.contains(event.target) && !sideMenuOpen.contains(event.target)) {
                closeMenus();
            }
        });
    } );
}

if (sideMenuClose) {
    sideMenuClose?.addEventListener( 'click', () => {
        closeMenus();
    } );
}

/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu ) {
    header?.setAttribute( 'data-menu-active', menu );

    if (window.innerWidth < 1024) {
        toggleScroll(false);
    }
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

/**
 * Debounce function to limit the frequency of function calls
 * @param {Function} func - The function to debounce
 * @param {number} wait - The debounce delay in milliseconds
 * @return {Function} - The debounced function
 */
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const scrollIndicator = getById('site-header-scroll-indicator');
if (header && scrollIndicator) {
    let lastScrollY = window.scrollY;
    let scrollOffset = splitNav?.offsetHeight + 2;

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        // console.log('scrollOffset', scrollOffset);
        // console.log('scrollAmount:', Math.abs(currentScrollY - lastScrollY));

        // Ignore small scroll amounts
        if (Math.abs(currentScrollY - lastScrollY) <= 100) {
            return;
        }

        if (currentScrollY > lastScrollY) {
            header.setAttribute('data-scrolled', 'true');
        } else {
            header.removeAttribute('data-scrolled');
        }

        lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
}

document.addEventListener('DOMContentLoaded', function () {
    const leftMenu = getById('left-menu');
    const rightMenu = getById('right-menu');
    const leftMenuContent = getById('left-menu-content');
    const rightMenuContent = getById('right-menu-content');
    const leftHeading = getById('left-heading');
    const rightHeading = getById('right-heading');

    if (leftMenu && rightMenu && leftMenuContent && rightMenuContent && leftHeading && rightHeading) {
        const transitionDuration = 300;

        const toggleNav = (activeMenu, inactiveMenu, activeContent, inactiveContent) => {
            inactiveContent.classList.add('fade-out');
            activeContent.classList.add('fade-out');

            setTimeout(() => {

                // If mobile menu is open, close it
                if (header.getAttribute('data-menu-active') === 'side') {
                    toggleMenu('side');
                }

                // inactiveContent.classList.add('hidden');
                inactiveContent.classList.remove('fade-in');
                // activeContent.classList.add('hidden');
                activeContent.classList.remove('fade-in');

                activeMenu.classList.add('active');
                inactiveMenu.classList.remove('active');

                setTimeout(() => {
                    activeContent.classList.remove('fade-out');
                    activeContent.classList.add('fade-in');
                }, transitionDuration);
            }, transitionDuration);

            sessionStorage.setItem('navPreference', activeMenu.id.includes('left') ? 'left' : 'right');
        };

        const navPreference = sessionStorage.getItem('navPreference');
        if (navPreference === 'right') {
            toggleNav(rightMenu, leftMenu, rightMenuContent, leftMenuContent);
        } else {
            toggleNav(leftMenu, rightMenu, leftMenuContent, rightMenuContent);
        }

        leftHeading.addEventListener('click', () => toggleNav(leftMenu, rightMenu, leftMenuContent, rightMenuContent));
        rightHeading.addEventListener('click', () => toggleNav(rightMenu, leftMenu, rightMenuContent, leftMenuContent));
    }
});
